module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-988-retro.c8ae9243.jpg";